import { render } from "./Monthlyeventstatistics.vue?vue&type=template&id=74700f2a"
import script from "./Monthlyeventstatistics.vue?vue&type=script&lang=js"
export * from "./Monthlyeventstatistics.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ChenHao/www/xiaohangjia/zhy_dataview_fe/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__